const list = ['EQ001','EQ002','EQ003','EQ004','EQ005','EQ006','PR07','PV62','PV63','PV64','LF52'];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/cdn/m3-eq-tip/';
const img_file = '.jpg';

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
}